<div class="device-screen-container">
    <div class="header">{{ 'display_screen_title' | xsI18n }}</div>
    <div class="dialog-header-separator"></div>
    <div class="divider"></div>
    <form [formGroup]="form">
        <mat-radio-group formControlName="displayScreen">
            <mat-radio-button *ngFor="let option of availableDisplays" class="mat-option-button" [disableRipple]="true"
                [value]="option" [checked]="option.id == selectDisplayId">
                <div *ngIf="option.width > 0; else uninitialised">{{ option.name }} ({{ option.width }} x {{ option.height }})</div>
                <ng-template #uninitialised>{{ option.name }}</ng-template>
            </mat-radio-button>
        </mat-radio-group>
    </form>
    <div class="divider wide"></div>
    <div class="buttons">
        <button class="xs-btn btn-outline btn-cancel" (click)="onClose()">
            <span>{{ 'xs_cancel_label' | xsI18n }}</span>
        </button>
        <button class="xs-btn btn-primary" (click)="onSubmit()" type="submit">
            <span>Select<!--{{ 'save_Cancel_Bar_Select_Button' | xsI18n }}--></span>
        </button>
    </div>
</div>